var PermissionTypes = {
  Permissions_Administrator: "admin_access",
  user_access: "user_access",
  accountant_access: "accountant_access",
  chef_access: "chef_access",
  user_read: "user_read",
  user_write: "user_write",
  user_remove: "user_remove",
  stockcard_read: "stockcard_read",
  stockcard_write: "stockcard_write",
  stockcard_remove: "stockcard_remove",
  sale_screen: "sale_screen",
  discount_loss_create: "discount_loss_create",
  main_dashboard: "main_dashboard",
  hot_sale_record_read: "hot_sale_record_read",
  total_giro_report_read: "total_giro_report_read",
  expense_read_write: "expense_read_write",
  discount_read: "discount_read",
  envanter_report_read: "envanter_report_read",
  branch_giro_report_read: "branch_giro_report_read",
  category_report_read: "category_report_read",
  product_giro_report_read: "product_giro_report_read",
  time_giro_report_read: "time_giro_report_read",
  date_giro_report_read: "date_giro_report_read",
  rawmaterial_consume_report_read: "rawmaterial_consume_report_read",
  wallet_consume_report_read: "wallet_consume_report_read",
  stock_list_read: "stock_list_read",
  stock_quantity_read: "stock_quantity_read",
  loss_read: "loss_read",
  stock_taking_create_read: "stock_taking_create_read",
  product_list_read: "product_list_read",
  product_category_list_read: "product_category_list_read",
  rawmaterial_list_read: "rawmaterial_list_read",
  rawmaterial_category_list_read: "rawmaterial_category_list_read",
  receipt_list_read: "receipt_list_read",
  extra_list_read: "extra_list_read",
  cup_sizes_read: "cup_sizes_read",
  branch_list_read : "branch_list_read",
  supplier: "supplier",
  unit_read: "unit_read",
  expense_type: "expense_type",
  payment_type: "payment_type",
  day_report_read: "day_report_read",
  pos_settings: "pos_settings",
  bill_read_create: "bill_read_create",
  branch_comparison_report: "branch_comparison_report",
  mood_report_read: "mood_report_read",
  campaign_gift_report: "campaign_gift_report",
  campaign_read: "campaign_read",
  draw_read: "draw_read",
  half_made_read: "half_made_read",
  loss_reason_read: "loss_reason_read",
  mood_felek_settings: "mood_felek_settings",
  panel_settings: "panel_settings",
  mood_image_settings: "mood_image_settings",
  price_list_read: "price_list_read",
  discount_reasons_read:"discount_reasons_read",
  wallet_accounting_report: "wallet_accounting_report",
  self_service_session_log_read: "self_service_session_log_read",
  day_report_diffrence_read: "day_report_diffrence_read",
  day_report_export: "day_report_export",
  day_report_difference: "day_report_difference",
  day_report_create: "day_report_create"
  // TODO: Backend'deki Permission type'lar buraya tek tek yazılmalı
};

/** Personel İşlem Raporu (self servis oturum logları) menü + rota + API: bu izinlerden biri yeterli. */
export const selfServiceSessionLogPagePermissionsAny = [
  PermissionTypes.self_service_session_log_read,
  PermissionTypes.sale_screen,
  PermissionTypes.hot_sale_record_read,
  PermissionTypes.total_giro_report_read,
  PermissionTypes.envanter_report_read,
  PermissionTypes.branch_giro_report_read,
  PermissionTypes.category_report_read,
  PermissionTypes.product_giro_report_read,
  PermissionTypes.time_giro_report_read,
  PermissionTypes.date_giro_report_read,
  PermissionTypes.rawmaterial_consume_report_read,
  PermissionTypes.wallet_consume_report_read,
  PermissionTypes.branch_comparison_report,
  PermissionTypes.mood_report_read,
  PermissionTypes.day_report_read,
  PermissionTypes.day_report_diffrence_read,
  PermissionTypes.day_report_export,
  PermissionTypes.day_report_difference,
  PermissionTypes.day_report_create,
  PermissionTypes.wallet_accounting_report,
  PermissionTypes.campaign_gift_report,
  PermissionTypes.Permissions_Administrator,
  PermissionTypes.main_dashboard
];

export default PermissionTypes;
